export function parseTimer(value) {
    let raw = value;
    if (typeof raw === "string") {
        try {
            raw = JSON.parse(raw);
        } catch {
            raw = null;
        }
    }
    if (!raw || typeof raw !== "object") {
        return { running: false, startedAt: null, elapsedMs: 0 };
    }
    return {
        running: Boolean(raw.running),
        startedAt: raw.startedAt || null,
        elapsedMs: Number(raw.elapsedMs) || 0,
    };
}

export function startTimer(value) {
    const t = parseTimer(value);
    if (t.running) return t;
    return {
        running: true,
        startedAt: new Date().toISOString(),
        elapsedMs: t.elapsedMs,
    };
}

export function pauseTimer(value) {
    const t = parseTimer(value);
    if (!t.running || !t.startedAt) {
        return { running: false, startedAt: null, elapsedMs: t.elapsedMs };
    }
    const extra = Date.now() - new Date(t.startedAt).getTime();
    return {
        running: false,
        startedAt: null,
        elapsedMs: t.elapsedMs + Math.max(0, extra),
    };
}

export function timerElapsedMs(value, now = Date.now()) {
    const t = parseTimer(value);
    if (t.running && t.startedAt) {
        return t.elapsedMs + Math.max(0, now - new Date(t.startedAt).getTime());
    }
    return t.elapsedMs;
}

export function formatElapsed(ms) {
    const total = Math.max(0, Math.floor(Number(ms) / 1000));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const pad = (n) => String(n).padStart(2, "0");
    return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}
